module.exports = __webpack_public_path__ + "img/desktop_platform_top_img.a65dcdd3.jpg";